import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Keeps already-shared /partners?seller=<slug> links working.
 *
 * The old route was `<Navigate to="/wifi-partners" replace />`, which throws
 * the query string away — so a shopper coming from a partner's Facebook post
 * arrived at the full marketplace with no idea which card was the seller they
 * tapped. Those links are out in the world and cannot be recalled, so the
 * address forwards to that seller's own page instead.
 *
 * Without a slug it behaves exactly as before: straight to the marketplace.
 */
const LegacySellerLink: React.FC = () => {
   const [params] = useSearchParams();
   const slug = params.get('seller')?.trim();

   if (slug) {
      return <Navigate to={`/s/${encodeURIComponent(slug)}`} replace />;
   }
   return <Navigate to="/wifi-partners" replace />;
};

export default LegacySellerLink;
